module.exports = __webpack_public_path__ + "img/icon-diabetology-inactive.d32fdfc4.png";